import React, { Component } from "react";
// import { Modal } from "carbon-components-react";
import Modal from "@acadia-ui/modal";
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
// import "./modal.scss";
import "./DeletePlatformModal.scss";
import ModalHelpers from "./ModalHelpers";
import { deletePlatform, bulkDeletePlatform } from "../../Flux/Actions/WorkbookActions";

const formEl = "delete-platform-modal";

class DeletePlatformModal extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.deletePlatformModal(this);
	}

	componentWillUnmount() {
		this.props.deletePlatformModal(undefined);
	}

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		this.updateModalState();

		// if (event) {
		// 	if (!event.currentTarget.classList.contains("bx--modal")) {
		// 		ModalHelpers.openCloseNoData(event, this.updateModalState, this.state);
		// 	}
		// } else {
		// 	ModalHelpers.openCloseNoData(event, this.updateModalState, this.state);
		// }
	};

	updateModalState = () => {
		!this.state.open ? Modal.show(`${formEl}-${this.props.type}`) : Modal.hide(`${formEl}-${this.props.type}`);
		this.setState({ open: !this.state.open });
	};

	handleSubmit = (e) => {
		e.preventDefault();
		if (this.props.multiple === true) {
			bulkDeletePlatform(
				this.props.hierarchyLevel,
				this.props.data.map((lineItem) => {
					return lineItem[`${this.props.hierarchyLevel}ID`];
				}),
				this.props.deleteType,
				this.props.onFailure
			);
		} else if (this.props.type === "Insertion Order") {
			this.props.handleDelete(this.props.data);
		} else {
			deletePlatform(this.props.data.hierarchyLevel, this.props.data.id, this.props.data.deleteType);
		}
		Modal.hide(`${formEl}-${this.props.type}`);
		this.setState({ open: false });
		this.props?.onSubmit?.();
	};

	renderContent = () => {
		if (this.props.multiple === true) {
			const selectedLines = this.props.data.sort((a, b) => {
				if (a.Row < b.Row) {
					return -1;
				}
				if (a.Row > b.Row) {
					return 1;
				}
				return 0;
			});

			return [
				<ul style={{ paddingRight: "35px", display: "inline-block" }}>
					<li key="header" className="bx--modal-delete">
						<span className="row">
							<u>Row</u>
						</span>
					</li>
					{selectedLines.map((data) => {
						return (
							<li key={"row__" + data.Row} className="bx--modal-delete-item">
								<span style={{ paddingRight: "60px" }} className="row">
									{data.Row + 1}
								</span>
							</li>
						);
					})}
				</ul>,
				<ul style={{ display: "inline-block" }}>
					<li key="header" className="bx--modal-delete">
						<span className="placement">
							<u>{this.props.type} Name</u>
						</span>
					</li>
					{selectedLines.map((data) => {
						return (
							<li key={`${this.props.hierarchyLevel}__${data.Row}`} className="bx--modal-delete-item">
								<span className="placement">{data[`${this.props.hierarchyLevel}Name`]}</span>
							</li>
						);
					})}
				</ul>
			];
		}

		return (
			<>
				<p>Are you sure you wish to delete this {this.props.type}?</p>
				{this.props.type === "Insertion Order" && this.props.data[0]?.ChildCount !== "0" && (
					<p className="deleteText" style={{ color: "red" }}>
						You have {this.props.data[0]?.ChildCount} {this.props.data[0]?.ChildCount !== "1" ? " line items" : " line item"} in this insertion order. If you delete
						this insertion order you will delete all line item(s).
					</p>
				)}
			</>
		);
	};

	render() {
		const label = `Delete ${this.props.type}`;

		return (
			<Modal
				// danger={true}
				id={`${formEl}-${this.props.type}`}
				className="deletePlatformModal"
				heading={label}
				onRequestClose={this.triggerOpenClose}
				size="medium"
				// userClosable={true}
				actionSetProps={{
					actionsRight: (
						<>
							<Button
								display={BUTTON_DISPLAY.SECONDARY}
								onClick={() => {
									Modal.hide(`${formEl}-${this.props.type}`);
									this.setState({ open: false });
								}}
								data-tracking-id-alt="cancel-delete-platform"
							>
								Cancel
							</Button>
							<Button onClick={this.handleSubmit} data-tracking-id-alt="confirm-delete-platform">
								Delete
							</Button>
						</>
					)
				}}
				onClick={() => {}}
			>
				{/* {this.renderContent()} */}
				{this.props.children}
			</Modal>
		);
	}
}

export default DeletePlatformModal;
